var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header",attrs:{"role":"banner"}},[_c('div',{staticClass:"header__line header__line--logo-line"},[_c('Logo',{staticClass:"header__line--logo"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }